export default {
  orderStatus: {
    CONFIRMED: 'confirmed',
    PAID: 'paid',
    PROCESSED: 'processed',
    DELIVERED: 'delivered',
    CANCELED: 'canceled',
    INVOICES_ISSUED: 'invoces_issued',
    INVOICES_ISSUED_PARTIALLY: 'invoces_issued_partially',
    ON_CARRIAGE: 'on_carriage',
    FINISHED: 'finished',
  },
  paymentType: {
    CREDIT: 'credit',
    DEBIT: 'debit',
    BANK_SLIP: 'bank_slip',
    BILLING: 'billing',
    ESTIMATE: 'estimate',
    GETNET: 'getnet',
  },
  paymentLabels: {
    credit: 'credit',
    debit: 'debit',
    bank_slip: 'bankSlip',
    billing: 'biling',
    estimate: 'estimate',
  },
  paymentStatus: {
    AUTHORIZED: 'authorized',
    NOT_AUTHORIZED: 'not_authorized',
    INDEFINITE: 'indefinite',
    CANCELED: 'canceled',
    CAPTURED: 'captured',
    NOT_FINISHED: 'not_finished',
  },
  paymentStatusPagSeguro: {
    AWAIT_PAYMENT: 'Aguardando Pagamento',
    IN_REVIEW: 'Em Análise',
    PAID: 'Paga',
    AVAILABLE: 'Disponível',
    IN_DISPUTE: 'Em Disputa',
    RETURNED: 'Devolvida',
    CANCELED: 'Cancelada',
    DEBITED: 'Debitado',
    TEMPORARY_RETENTION: 'Retenção temporária',
    INDEFINITE: 'indefinite',
  },
  paymentStatusGetnet: {
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
  },
  paymentTerms: {
    FOB: 'fob',
    CIF: 'cif',
    CIF_REDISPATCH: 'cif_redispatch',
  },
  purposes: {
    CONSUPTION: 'consumption',
    INDUSTRIALIZATION: 'industrialization',
    RESALE: 'resale',
  },
  approverStatus: {
    APPROVED: 'approved',
    CANCELED: 'canceled',
    OPEN: 'open',
  },
  registrationStatus: {
    SPHERE: 'sphere',
    CHECKBUY: 'PendingClientCheckbuy',
    CONTACT_NOT_IN_CHECKBUY: 'PendingUserClient',
    CONTACT_IN_CHECKBUY: true,
  },
};
